import { render, staticRenderFns } from "./BusinessFirstPage.vue?vue&type=template&id=670c9699&scoped=true&"
import script from "./BusinessFirstPage.vue?vue&type=script&lang=js&"
export * from "./BusinessFirstPage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessFirstPage.vue?vue&type=style&index=0&id=670c9699&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c9699",
  null
  
)

export default component.exports